import {
  TranscriptChange,
  TranscriptElement,
  TranscriptPunctElement,
} from '../../types.ts/transcript';
import {
  getClosestNotRemovedElementIndexToRight,
  getClosestNotRemovedElementIndexToLeft,
  isSentenceEnd,
} from '../utils';
import ChangeHandler from './ChangeHandler';

const ALPHANUMERIC_NOT_EMPTY_UNICODE = /[\p{L}\p{N}]/u;

class ReplaceChangeHandler extends ChangeHandler {
  apply(
    transcriptionElementsMutable: TranscriptElement[],
    change: TranscriptChange & { type: 'replace' },
  ) {
    const _elements = transcriptionElementsMutable;

    const elementsCount = change.count || 1;
    let startTs = null;
    let endTs = null;
    let i = 0;
    let lastReplacedTextElementIdx = -1;

    if (
      change.newValue?.match(ALPHANUMERIC_NOT_EMPTY_UNICODE) &&
      !change.oldValue?.match(ALPHANUMERIC_NOT_EMPTY_UNICODE)
    ) {
      console.warn(
        `Replace old value "${change.oldValue}" with new value "${change.newValue}" not allowed, text cannot be inserted with replace`,
      );
      return;
    }

    while (i < elementsCount) {
      let element = _elements[change.index + i];
      element.old_value = element.value;
      element.state = change.retainState ? element.state : 'replaced';
      element.value = '';

      if (startTs === null && element.ts != null) {
        startTs = element.ts;
      }
      if (element.end_ts != null) {
        endTs = element.end_ts;
      }
      if (element.type === 'text') {
        lastReplacedTextElementIdx = change.index + i;
        element = {
          ...element,
          type: 'punct',
          ts: null,
          end_ts: null,
        } as TranscriptPunctElement;
      }
      i++;
    }

    let extraSpaceAfter = '';
    let nextElementIndex = getClosestNotRemovedElementIndexToRight(
      change.index + elementsCount,
      _elements,
    );
    if (
      !change.newValue?.endsWith(' ') &&
      nextElementIndex > -1 &&
      _elements[nextElementIndex].type === 'text' &&
      !_elements[nextElementIndex].value?.startsWith(' ')
    ) {
      extraSpaceAfter = ' ';
    }

    let extraSpaceBefore = '';
    let prevElementIndex = getClosestNotRemovedElementIndexToLeft(
      change.index - 1,
      _elements,
    );
    if (
      !change.newValue?.startsWith(' ') &&
      prevElementIndex > -1 &&
      !_elements[prevElementIndex].value?.endsWith(' ') &&
      change.newValue?.match(ALPHANUMERIC_NOT_EMPTY_UNICODE)
    ) {
      extraSpaceBefore = ' ';
    }

    if (
      startTs &&
      endTs &&
      lastReplacedTextElementIdx > -1 &&
      change.newValue?.match(ALPHANUMERIC_NOT_EMPTY_UNICODE)
    ) {
      _elements[lastReplacedTextElementIdx].ts = startTs;
      _elements[lastReplacedTextElementIdx].end_ts = endTs;
      _elements[lastReplacedTextElementIdx].type = 'text';
      _elements[lastReplacedTextElementIdx].value =
        extraSpaceBefore + change.newValue + extraSpaceAfter;
    } else {
      _elements[change.index + elementsCount - 1].value =
        extraSpaceBefore + change.newValue + extraSpaceAfter;
    }

    if (isSentenceEnd(change.newValue!) !== isSentenceEnd(change.oldValue!)) {
      this.fixCapitalizationAt(_elements, change.index + change.count);
    }
  }
}

export default ReplaceChangeHandler;
